import { defineStore } from "pinia";

export const useCoTransactionStore = defineStore("coTransaction", {
  state: () => ({
    coTransactionId: localStorage.getItem("coTransactionId"),
    coId: localStorage.getItem("coId"),
  }),
  actions: {
    setTransaction(coId: string, coTransactionId: string) {
      this.coId = coId;
      this.coTransactionId = coTransactionId;
      localStorage.setItem("coId", coId);
      localStorage.setItem("coTransactionId", coTransactionId);
    },
    clearTransaction() {
      this.coId = null;
      this.coTransactionId = null;
      localStorage.removeItem("coId");
      localStorage.removeItem("coTransactionId");
    },
  },
});
